type Arguments = {
  pageWidth: number;
  pageHeight: number;
  flagX: number;
  flagY: number;
  width: number;
  height: number;
  padding: number;
};

type Position = {
  x: number;
  y: number;
};

export const generatePosition = ({
  pageWidth,
  pageHeight,
  flagX,
  flagY,
  width,
  height,
  padding
}: Arguments): Position => {
  // Prepare
  let x = flagX;
  let y = flagY;
  let maxWidth;
  let maxHeight;

  // Mode

  // set maxes
  maxWidth = pageWidth;
  maxHeight = pageHeight;
  // center
  x -= width / 2;
  y -= height / 2;

  // Adjust Left
  if (x + width + padding > maxWidth) {
    x = maxWidth - width - padding;
  }
  if (x < padding) {
    x = padding;
  }

  // Adjust Top
  if (y + height + padding > maxHeight) {
    y = maxHeight - height - padding;
  }
  if (y < padding) {
    y = padding;
  }

  // Return
  return { x, y };
};
